import React from 'react';
import translate from '../../i18n/translate';

/**
 * FundingCrisis — explains the problem Metha solves.
 * Three cards summarising the dysfunction of biomedical research funding:
 * grant success rates, overhead extraction, and the funding gap.
 *
 * All copy comes from existing i18n keys (vision-1-*) already aligned with
 * the paper and translated to EN/ES/FR.
 */
export default function FundingCrisis() {
  return (
    <section className="lv2-section lv2-section--crisis" id="crisis" style={{ paddingTop: 80 }}>
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('vision-ticker-1')}</span>
          <h2>{translate('vision-title-1')}</h2>
        </div>
        <div className="lv2-vision-grid">
          <article className="lv2-vision-card">
            <span className="lv2-vision-cond">01 · BUREAUCRACY</span>
            <p>{translate('vision-1-1')}</p>
          </article>
          <article className="lv2-vision-card">
            <span className="lv2-vision-cond">02 · EXTRACTION</span>
            <p>{translate('vision-1-2')}</p>
          </article>
          <article className="lv2-vision-card">
            <span className="lv2-vision-cond">03 · THE GAP</span>
            <p>{translate('vision-1-3')}</p>
          </article>
        </div>
      </div>
    </section>
  );
}
